export const CDN_PATH = 'https://cdn.kespa.ru/audio/magic-piano/';
